import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=c63d5678&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=ts&"
export * from "./ContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=c63d5678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63d5678",
  null
  
)

export default component.exports